import React, { useState, useEffect } from 'react';
import { Lightbulb, ArrowUpRight, X, Sparkles, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

const TopHeader = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);

  // Optional: Auto-hide after some time
  useEffect(() => {
    const timer = setTimeout(() => {
      // Uncomment below if you want auto-hide feature
      // handleClose();
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, []);

  const handleClose = (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setIsAnimating(true);
    setTimeout(() => setIsVisible(false), 300);
  };

  if (!isVisible) return null;

  return (
    <div className={`relative bg-gradient-to-r from-purple-500 via-purple-400 to-purple-300 border-b border-purple-600/30 transition-all duration-300 overflow-hidden ${
      isAnimating ? 'opacity-0 h-0' : 'opacity-100 h-auto'
    }`}>
      {/* Animated background effect */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -inset-10 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 animate-shimmer"></div>
      </div>

      <Link
        to="https://digitalcards.tech/"
        target="_blank"
        rel="noopener noreferrer"
        className="block w-full relative z-10 hover:no-underline"
      >
        <div className="max-w-7xl mx-auto px-3 sm:px-4 py-2 sm:py-3">
          {/* Mobile Layout - Stacked */}
          <div className="sm:hidden flex flex-col gap-2 items-center text-center">
            {/* Icon and Badge */}
            <div className="flex items-center gap-2 bg-white/20 rounded-full px-2 py-1 border border-white/30">
              <Zap className="w-3 h-3 text-white" />
              <span className="text-xs font-bold text-white uppercase tracking-wide">
                New
              </span>
            </div>

            {/* Text Content */}
            <div className="flex items-center gap-2 justify-center">
              <Sparkles className="w-3 h-3 text-white flex-shrink-0" />
              <div className="text-center">
                <span className="text-xs font-semibold text-white block">
                  Launching Soon:
                </span>
                <span className="text-xs text-white/90 font-medium">
                  digitalcards.tech
                </span>
              </div>
            </div>

            {/* CTA Button - Mobile */}
            <div className="flex items-center gap-2 bg-white hover:bg-white/90 text-purple-600 px-3 py-1.5 rounded-lg font-semibold text-xs transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl group">
              <span>Get Early Access</span>
              <ArrowUpRight className="w-3 h-3 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </div>
          </div>

          {/* Desktop Layout - Horizontal */}
          <div className="hidden sm:flex items-center justify-between gap-4">
            {/* Left Side: Content */}
            <div className="flex items-center gap-3 flex-1 min-w-0">
              {/* Icon */}
              <div className="flex items-center gap-2 bg-white/20 rounded-full px-2 py-1 border border-white/30">
                <Zap className="w-3 h-3 text-white" />
                <span className="text-xs font-bold text-white uppercase tracking-wide">
                  New
                </span>
              </div>

              {/* Text Content */}
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <Sparkles className="w-4 h-4 text-white flex-shrink-0" />
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 min-w-0">
                  <span className="text-sm font-semibold text-white whitespace-nowrap">
                    Launching Soon:
                  </span>
                  <span className="text-sm text-white/90 font-medium truncate">
                    digitalcards.tech – Create Your Digital Business Card
                  </span>
                </div>
              </div>
            </div>

            {/* Right Side: CTA & Close */}
            <div className="flex items-center gap-4">
              {/* CTA Button */}
              <div className="flex items-center gap-2 bg-white hover:bg-white/90 text-purple-600 px-4 py-2 rounded-lg font-semibold text-sm transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl group">
                <span>Get Early Access</span>
                <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </div>

              {/* Close Button - Only show on larger screens */}
              <button
                onClick={handleClose}
                className="flex items-center justify-center w-6 h-6 text-white/80 hover:text-white hover:bg-white/20 rounded transition-all duration-200"
                aria-label="Close banner"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </Link>

      {/* Mobile close button */}
      <button
        onClick={handleClose}
        className="sm:hidden absolute top-2 right-2 z-20 w-6 h-6 flex items-center justify-center text-white/80 hover:text-white hover:bg-white/20 rounded transition-all duration-200"
        aria-label="Close banner"
      >
        <X className="w-4 h-4" />
      </button>

      {/* Progress bar for auto-dismiss */}
      <div className="absolute bottom-0 left-0 w-full h-0.5 bg-white/20">
        <div className="h-full bg-white/40 animate-progress w-full"></div>
      </div>
    </div>
  );
};

export default TopHeader;